/* bs-seo-text — "Leer más / Leer menos" del bloque de texto SEO.
 *
 * El colapso lo hace el CSS con max-height sobre .bs-js, así que aquí solo se
 * conmuta data-expanded y se intercambian las etiquetas del botón. El texto
 * nunca se saca del DOM ni se pone display:none: es contenido para posicionar
 * y tiene que seguir siendo rastreable.
 *
 * Se reengancha en shopify:section:load para que funcione en el editor de temas.
 */
(function () {
  'use strict';

  function init(scope) {
    (scope || document).querySelectorAll('[data-bs-seo-wrap]').forEach(function (wrap) {
      if (wrap.__bsSeoInit) return;
      wrap.__bsSeoInit = true;

      var btn = wrap.querySelector('[data-bs-seo-toggle]');
      var rest = wrap.querySelector('[data-bs-seo-rest]');
      var more = wrap.querySelector('[data-bs-seo-more]');
      var less = wrap.querySelector('[data-bs-seo-less]');
      if (!btn || !rest) return;

      btn.addEventListener('click', function () {
        var abriendo = !wrap.hasAttribute('data-expanded');
        if (abriendo) wrap.setAttribute('data-expanded', '');
        else wrap.removeAttribute('data-expanded');

        btn.setAttribute('aria-expanded', abriendo ? 'true' : 'false');
        if (more) more.hidden = abriendo;
        if (less) less.hidden = !abriendo;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
